const MessageTypes = require("../message-types");

/**
 * @typedef {Object} Message
 * @property {String} type The type of the message, right now we only support 'text'
 * @property {String} content The main content of the message
 * @property {String} sentAt ISO String timestamp
 */

/**
 * Send a direct message to another user.
 * @param socket
 * @param {String} receiverInternalId
 * @param {Message} message
 * @param {String?} roomId
 */
module.exports.sendDirectMessage = (socket, receiverInternalId, message, roomId = null) => {
  socket.emit(MessageTypes.SEND_DIRECT_MESSAGE, { receiverInternalId, message, roomId });
};



// WEBPACK FOOTER //
// ../node_modules/@flic-chat/js-sdk/src/api/messages.js